import { AGENT_STATUS } from '../../core/constants/domain';
import { toArray, toId, toText } from './list';

export function normalizeSeat(raw) {
    const task = raw?.work?.task;
    return {
        id: toId(raw?.id),
        label: toText(raw?.label ?? raw?.workspace_label, `Puesto ${raw?.id ?? ''}`.trim()),
        role: raw?.role ?? null,
        provider: raw?.provider ?? null,
        repositoryId: toId(raw?.repository_id ?? raw?.repository),
        userId: toId(raw?.user_id ?? raw?.person),
        machineLabel: raw?.machine?.label ?? null,
        lastSeenAt: raw?.machine?.last_seen_at ?? null,
        presence: raw?.presence?.state ?? null,
        controlState: raw?.control?.effective_state ?? null,
        workState: raw?.work?.state ?? null,
        task: task ? {
            id: toId(task.id),
            title: toText(task.title, `Tarea ${task.id}`),
            claimedAt: task.claimed_at ?? null,
            claimedUntil: task.claimed_until ?? null,
        } : null,
        staleReasons: toArray(raw?.staleness?.reasons),
    };
}

// Coordination exposes presence, control, work and staleness as separate
// blocks; the UI collapses them into one readable status. Blocked wins over
// everything because it is what a person must act on.
export function deriveAgentStatus(seat, { isPausedLocally = false } = {}) {
    if (seat.staleReasons.some((reason) => reason !== 'sin_conexion' && reason !== 'sin_latidos')
        || seat.workState === 'vigencia_vencida') {
        return AGENT_STATUS.BLOCKED;
    }
    if (seat.presence === 'sin_conexion' || seat.staleReasons.includes('sin_latidos')) return AGENT_STATUS.OFFLINE;
    if (isPausedLocally || seat.controlState === 'pausado') return AGENT_STATUS.WAITING;
    if (seat.workState === 'corriendo') return AGENT_STATUS.RUNNING;
    return AGENT_STATUS.CONNECTED;
}
